import ImageAndTextHeroBlock from 'libs/wordpress/content/cmsBlocks/ImageAndTextHeroBlock';
import React from 'react';
import ratios from 'config/theme/ratios';
import styled from 'libs/styled';
import { above } from 'utils/mediaqueries';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import moduleMargins from 'config/theme/moduleMargins';

const Section = styled(MaxWidthWrapper)`
    position: relative;
    aspect-ratio: ${ratios.square};
    padding: 0 12px;

    ${above.sm} {
        height: 33vw;
        aspect-ratio: unset;
        padding: 0 24px;
    }
`;

const ImageAndTextHeroModule = ({ ...props }) => (
    <Section
        includeContentMargins
        as="section"
        py={moduleMargins.md}>
        <ImageAndTextHeroBlock useGridWrapper useMaxWidth headingSize="lg" {...props} />
    </Section>
);

export default ImageAndTextHeroModule;
